import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';

const MetricCard = ({
  title,
  value,
  change,
  subtitle,
  icon: Icon,
  iconColor = 'text-blue-600',
  iconBgColor = 'bg-blue-100'
}) => {
  const isPositiveChange = change && change.value > 0;
  const isNegativeChange = change && change.value < 0;

  return (
    <div className="bg-white overflow-hidden shadow rounded-lg">
      <div className="p-5">
        <div className="flex items-center">
          <div className="flex-shrink-0">
            <div className={`w-12 h-12 ${iconBgColor} rounded-lg flex items-center justify-center`}>
              <Icon className={`h-6 w-6 ${iconColor}`} />
            </div>
          </div>
          <div className="ml-5 w-0 flex-1">
            <dl>
              <dt className="text-sm font-medium text-gray-500 truncate">
                {title}
              </dt>
              <dd className="flex items-baseline">
                <div className="text-2xl font-semibold text-gray-900">
                  {typeof value === 'number' ? value.toLocaleString() : value}
                </div>
                {change && (
                  <div className={`ml-2 flex items-baseline text-sm font-semibold ${
                    isPositiveChange ? 'text-green-600' : isNegativeChange ? 'text-red-600' : 'text-gray-500'
                  }`}>
                    {isPositiveChange && <TrendingUp className="h-4 w-4 mr-0.5" />}
                    {isNegativeChange && <TrendingDown className="h-4 w-4 mr-0.5" />}
                    {Math.abs(change.value)}%
                  </div>
                )}
              </dd>
              {subtitle && (
                <dd className="text-xs text-gray-500 mt-1">
                  {subtitle}
                </dd>
              )}
              {change?.period && (
                <dd className="text-xs text-gray-500 mt-1">
                  vs. {change.period}
                </dd>
              )}
            </dl>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MetricCard;
